import { ErrorLogComponent } from '@cian/error-log-component';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Provider } from 'react-redux';
import { PageContainer } from '../PageContainer';
import { ModalContainer } from '../ModalContainer';
import { TReduxStore } from '../../types/redux';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { ICustomContextParams } from '../../types/ICustomContextParams';
import { uaToDeviceType } from '@cian/ui-kit/utils';
import { ApplicationContext } from '../../reactContexts/applicationContext';
import { IApplicationContext } from '../../types/application';

export interface IApplicationProps extends IApplicationContext {
  reduxStore: TReduxStore;
  customContext: ICustomContextParams;
}

export type TApplicationСontextTypes = {
  [K in keyof IApplicationContext]: PropTypes.Requireable<IApplicationContext[K]>;
};

export const Application: React.FC<IApplicationProps> = ({ config, logger, httpApi, reduxStore, customContext }) => {
  const applicationContext: IApplicationContext = React.useMemo(
    () => ({
      logger,
      config,
      httpApi,
    }),
    [logger, config, httpApi],
  );

  return (
    <ApplicationContext.Provider value={applicationContext}>
      <ErrorLogComponent logger={logger}>
        <UiKitContextProvider deviceType={uaToDeviceType(customContext.userAgent)}>
          <Provider store={reduxStore}>
            <PageContainer />
            <ModalContainer />
          </Provider>
        </UiKitContextProvider>
      </ErrorLogComponent>
    </ApplicationContext.Provider>
  );
};
